// Справочник - каким методом был получен токен для сброса пароля: 0 = ByPhone, 1 = ByEmail

export const resetPasswordTypes = {
    ByPhone: 0,
    ByEmail: 1    
} 